import React from 'react'
// import About from "../components/Home/about.js" 
import Hero from "../components/Home/hero_section.jsx" 
import Services from '../components/Home/service.jsx'

import { Helmet } from 'react-helmet';

function Home() {
  return (
    <div>
      <Helmet>
  <title>Refyn Data - Software development and IT staffing agency</title>
  <meta name="description" content="Refyn Data is a software development and IT staffing agency with a global presence, including offices in the U.S. and India. We specialize in providing innovative IT solutions.." />
  <meta name="keywords" content="IT staffing solutions, IT recruitment, IT consulting, Refyn Data, IT services" />
</Helmet>

        <Hero/>
        {/* <About/> */}
        <Services/>
        

      
    </div>
  )
}

export default Home
